export default "__VITE_ASSET__0cee0527__"